import { MasonryEngineEvent } from '../types/masonry-engine-action.types';

export const formatEventName = (
  namespace: string,
  actionType: string,
  eventType: MasonryEngineEvent,
): `${string}-${MasonryEngineEvent}-${string}` =>
  `${namespace}-${eventType}-${actionType}`;
